// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signOut, updatePassword, sendEmailVerification } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";



// Initialize Firebase
const firebaseConfig = {
    apiKey: "AIzaSyDNH4CmrozM5jY4qRgk8e7Vu9zmBzDL5Xg",
    authDomain: "mps-web-app-8612d.firebaseapp.com",
    projectId: "mps-web-app-8612d",
    storageBucket: "mps-web-app-8612d.appspot.com",
    messagingSenderId: "24183654133",
    appId: "1:24183654133:web:3da08ff8d9c4ed1757a7bc"
  };


const app = initializeApp(firebaseConfig);
const auth = getAuth(app); // Initialize auth with the app instance
const dbFirestore = getFirestore(app); // Initialize dbFirestore with the app instance
const storage = getStorage(app);


export { auth, dbFirestore, storage, onAuthStateChanged, signOut, updatePassword, sendEmailVerification }; // Export auth and dbFirestore directly
export default app;